  (function () {
    var imageEntities = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
    function escapeImageAttribute(value) {
      return String(value || '').replace(/[&<>"']/g, function (character) { return imageEntities[character]; });
    }
    function responsiveImage(rawUrl, fallbackUrl) {
      var original = String(rawUrl || fallbackUrl || '').trim();
      try {
        var parsed = new URL(original, window.location.origin);
        if (/^(?:cdn\.)?shopify\.com$/i.test(parsed.hostname) || /\.shopifycdn\.com$/i.test(parsed.hostname)) {
          var sized = function (width) {
            var candidate = new URL(parsed.href);
            candidate.searchParams.set('width', String(width));
            return candidate.href;
          };
          return {
            src: escapeImageAttribute(sized(640)),
            srcset: escapeImageAttribute([320, 480, 640].map(function (width) { return sized(width) + ' ' + width + 'w'; }).join(', '))
          };
        }
      } catch (_) {}
      return { src: escapeImageAttribute(original), srcset: '' };
    }
    window.FlorameHomeFeedImages = Object.freeze({ escape: escapeImageAttribute, responsive: responsiveImage });

    var FILTER_SELECTOR = '[data-home-explore-filter]';
    var SECTION_SELECTOR = '[data-home-feed-section]';
    var labels = {
      all: 'Mostro i bouquet scelti per te.',
      available: 'Mostro i bouquet disponibili adesso.',
      trend: 'Mostro i bouquet più amati.',
      newest: 'Mostro le novità.',
      mine: 'Mostro le tue creazioni.',
      liked: 'Mostro i tuoi preferiti.'
    };
    var sectionByFilter = {
      all: 'homeCommunitySection',
      available: 'availableCarouselSection',
      trend: 'homeCommunitySection',
      newest: 'homeCommunitySection',
      mine: 'homeUserCreationsSection',
      liked: 'homeFavoritesSection'
    };
    var currentFilter = '';
    var occasionCatalog = window.FLORAME_OCCASION_CATALOG || {};
    var occasionValues = ['all'].concat((occasionCatalog.filterGroups || []).map(function (group) { return group.id; }));

    function normalizeOccasion(value) {
      var clean = String(value || '').toLowerCase();
      return occasionValues.indexOf(clean) >= 0 ? clean : 'all';
    }

    function syncOccasionButtons(value) {
      var occasion = normalizeOccasion(value);
      document.querySelectorAll('[data-home-sheet-occasion]').forEach(function (button) {
        var selected = button.getAttribute('data-home-sheet-occasion') === occasion;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    function normalizeFilter(value) {
      var clean = String(value || '').toLowerCase();
      if (clean === 'favorites') clean = 'liked';
      if (clean === 'trending') clean = 'trend';
      return Object.prototype.hasOwnProperty.call(sectionByFilter, clean) ? clean : 'all';
    }

    function hasPartnerPicks() {
      return document.documentElement.hasAttribute('data-florame-partner-storefront')
        || document.documentElement.hasAttribute('data-florame-partner-picks');
    }

    function isPartnerStorefront() {
      return document.documentElement.hasAttribute('data-florame-partner-storefront');
    }

    function defaultCatalogFilter() {
      return 'all';
    }

    function normalizeCatalogFilter(value) {
      return normalizeFilter(value);
    }

    function partnerSelectionLabel() {
      var lang = String(document.documentElement.getAttribute('lang') || '').slice(0, 2).toLowerCase();
      return lang === 'en' ? 'Today’s bouquets' : 'Bouquet di oggi';
    }

    function syncPartnerPickFilter(filter) {
      var partnerMode = filter === 'all' && hasPartnerPicks();
      var explore = document.getElementById('homeExplore');
      var community = document.getElementById('homeCommunitySection');
      if (explore) explore.classList.toggle('home-partner-picks-active', partnerMode);
      document.documentElement.classList.toggle('home-partner-picks-active', partnerMode);
      if (community) community.toggleAttribute('data-home-partner-picks-only', partnerMode);
      return partnerMode;
    }

    function filterFromLocation() {
      var params = new URLSearchParams(window.location.search);
      var fromQuery = params.get('f') || params.get('view') || params.get('filter') || params.get('type') || params.get('fv');
      if (fromQuery) return normalizeCatalogFilter(fromQuery);
      var hashMap = {
        '#availableCarouselSection': 'available',
        '#homeCommunitySection': 'newest',
        '#homeUserCreationsSection': 'mine',
        '#homeFavoritesSection': 'liked'
      };
      return normalizeCatalogFilter(hashMap[window.location.hash] || defaultCatalogFilter());
    }

    function writeFilterToUrl(filter, replace) {
      var url = new URL(window.location.href);
      var selectedPeriod = document.querySelector('[data-home-sheet-period].is-selected');
      var selectedSort = document.querySelector('[data-home-sheet-sort].is-selected');
      var selectedOccasion = document.querySelector('[data-home-sheet-occasion].is-selected');
      var period = selectedPeriod ? selectedPeriod.getAttribute('data-home-sheet-period') : 'all';
      var sort = filter === 'trend' ? 'likes' : (selectedSort ? selectedSort.getAttribute('data-home-sheet-sort') : 'newest');
      var occasion = normalizeOccasion(selectedOccasion ? selectedOccasion.getAttribute('data-home-sheet-occasion') : 'all');
      ['view', 'filter', 'type', 'fv'].forEach(function (key) { url.searchParams.delete(key); });
      if (filter === 'all') {
        url.searchParams.delete('f');
        url.searchParams.delete('sort');
        url.searchParams.delete('period');
      } else {
        url.searchParams.set('f', filter);
        if (filter === 'trend') url.searchParams.set('sort', 'likes');
        else url.searchParams.set('sort', sort);
      }
      if (period === 'all' || filter === 'all') url.searchParams.delete('period');
      else url.searchParams.set('period', period);
      if (occasion === 'all') url.searchParams.delete('occasion');
      else url.searchParams.set('occasion', occasion);
      url.hash = filter === 'all' ? '' : 'homeExplore';
      window.history[replace ? 'replaceState' : 'pushState']({ homeFeed: filter }, '', url.toString());
    }

    function activeAdvancedFilterCount() {
      var count = 0;
      var period = document.querySelector('[data-home-sheet-period].is-selected');
      var sort = document.querySelector('[data-home-sheet-sort].is-selected');
      var occasion = document.querySelector('[data-home-sheet-occasion].is-selected');
      if (period && period.getAttribute('data-home-sheet-period') !== 'all') count += 1;
      if (sort && sort.getAttribute('data-home-sheet-sort') !== 'newest') count += 1;
      if (occasion && normalizeOccasion(occasion.getAttribute('data-home-sheet-occasion')) !== 'all') count += 1;
      return count;
    }

    function syncAdvancedFilterCount() {
      var count = activeAdvancedFilterCount();
      document.querySelectorAll('[data-home-filter-count]').forEach(function (badge) {
        badge.hidden = count < 1;
        badge.textContent = String(count);
        badge.setAttribute('aria-label', count + (count === 1 ? ' filtro attivo' : ' filtri attivi'));
      });
      var trigger = document.querySelector('[data-home-filter-open]');
      if (trigger) trigger.classList.toggle('has-active-filters', count > 0);
    }

    function resetFilterControls(feed) {
      var normalizedFeed = normalizeCatalogFilter(feed || defaultCatalogFilter());
      var defaultSort = normalizedFeed === 'trend' ? 'likes' : 'newest';
      [normalizedFeed, 'all', defaultSort, 'all'].forEach(function (value, index) {
        var attr = index === 0 ? 'feed' : (index === 1 ? 'period' : (index === 2 ? 'sort' : 'occasion'));
        var target = document.querySelector('[data-home-sheet-' + attr + '="' + value + '"]');
        var group = target && target.closest('[data-home-filter-group]');
        if (group) group.querySelectorAll('button').forEach(function (item) { item.classList.remove('is-selected'); item.setAttribute('aria-pressed', 'false'); });
        if (target) { target.classList.add('is-selected'); target.setAttribute('aria-pressed', 'true'); }
      });
      syncAdvancedFilterCount();
    }

    function revealActiveFilter(activeLabel, behavior) {
      if (!activeLabel) return;
      var filterStrip = activeLabel.closest('.home-explore-filters');
      if (!filterStrip) return;
      var activeKey = activeLabel.getAttribute('data-home-explore-filter') || '';
      var nextLabel = activeKey === 'mine'
        ? activeLabel.nextElementSibling?.closest?.('[data-home-explore-filter]')
        : null;
      var visibleLeft = filterStrip.scrollLeft;
      var visibleRight = visibleLeft + filterStrip.clientWidth;
      var targetLeft = activeLabel.offsetLeft;
      var targetRight = nextLabel && nextLabel.parentElement === filterStrip
        ? nextLabel.offsetLeft + nextLabel.offsetWidth
        : activeLabel.offsetLeft + activeLabel.offsetWidth;
      if (targetLeft >= visibleLeft && targetRight <= visibleRight) return;
      var groupWidth = Math.max(activeLabel.offsetWidth, targetRight - targetLeft);
      var centeredLeft = targetLeft - Math.max(0, (filterStrip.clientWidth - groupWidth) / 2);
      centeredLeft = Math.max(0, Math.min(centeredLeft, filterStrip.scrollWidth - filterStrip.clientWidth));
      try { filterStrip.scrollTo({ left: centeredLeft, behavior: behavior || 'auto' }); }
      catch (_) { filterStrip.scrollLeft = centeredLeft; }
    }

    function setActiveFilter(filter, shouldScroll, shouldWriteUrl, replaceUrl) {
      filter = normalizeCatalogFilter(filter);
      currentFilter = filter;
      var links = Array.prototype.slice.call(document.querySelectorAll(FILTER_SELECTOR));
      var sections = Array.prototype.slice.call(document.querySelectorAll(SECTION_SELECTOR));
      var status = document.getElementById('homeExploreStatus');
      var targetId = sectionByFilter[filter];
      var partnerPicksActive = syncPartnerPickFilter(filter);

      if (filter === 'available') {
        var availableFeed = document.getElementById('availableCarousel');
        var availableEmpty = document.getElementById('availableEmptyState');
        var hasAvailableCards = availableFeed && availableFeed.querySelector('.snap-card:not(.skeleton)');
        var hasAvailableLoading = availableFeed && availableFeed.querySelector('.snap-card.skeleton');
        var hasAvailableMessage = availableEmpty && window.getComputedStyle(availableEmpty).display !== 'none';
        if (availableFeed && !hasAvailableCards && !hasAvailableLoading && !hasAvailableMessage) {
          availableFeed.style.display = 'grid';
          availableFeed.innerHTML = [
            '<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn"></div><div class="sk sk-btn"></div></div></div>',
            '<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn"></div><div class="sk sk-btn"></div></div></div>'
          ].join('');
        }
      }

      links.forEach(function (link) {
        var isActive = link.getAttribute('data-home-explore-filter') === filter;
        link.classList.toggle('is-active', isActive);
        if (isActive) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
        if (link.getAttribute('role') === 'tab') link.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      sections.forEach(function (section) {
        var sectionFeed = section.getAttribute('data-home-feed-section');
        var visible = filter === 'all'
          ? sectionFeed === 'newest'
          : ((filter === 'trend' || filter === 'newest') ? sectionFeed === 'newest' : sectionFeed === filter);
        section.hidden = !visible;
      });
      var capSection = document.querySelector('[data-home-address-section]');
      if (window.FlorameHomeAddress && typeof window.FlorameHomeAddress.setFeed === 'function') {
        window.FlorameHomeAddress.setFeed(filter);
      } else if (capSection) {
        capSection.hidden = false;
      }
      var partnerDirectory = document.querySelector('[data-florame-partner-directory-section]');
      if (partnerDirectory) partnerDirectory.hidden = filter !== 'all' && filter !== 'available';

      if (status) {
        status.textContent = partnerPicksActive
          ? 'Mostro la vetrina del fiorista.'
          : (labels[filter] || '');
      }
      var communityHeading = document.querySelector('#homeCommunitySection .section-head h3');
      if (communityHeading) {
        communityHeading.textContent = partnerPicksActive
          ? partnerSelectionLabel()
          : (filter === 'trend'
          ? 'Più amati'
          : (filter === 'all'
              ? (partnerPicksActive ? partnerSelectionLabel() : 'Per te')
              : 'Novità'));
      }
      var backToTop = document.querySelector('[data-home-feed-back-to-top]');
      var activeLabel = document.querySelector(FILTER_SELECTOR + '[data-home-explore-filter="' + filter + '"]');
      if (backToTop && activeLabel) backToTop.setAttribute('aria-label', 'Torna all’inizio di ' + activeLabel.textContent.trim());
      revealActiveFilter(activeLabel, shouldScroll ? 'smooth' : 'auto');
      if (shouldWriteUrl) writeFilterToUrl(filter, !!replaceUrl);
      document.documentElement.setAttribute('data-home-catalog-view', filter);
      syncAdvancedFilterCount();
      window.dispatchEvent(new CustomEvent('florame:home-feed-change', { detail: { filter: filter } }));
      if (!shouldScroll) return;

      var target = document.getElementById('homeExplore');
      if (!target) return;
      var reduceMotion = false;
      try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (_) {}
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }

    function selectCatalogView(view, options) {
      var settings = options || {};
      var filter = normalizeCatalogFilter(view);
      // La vetrina e una selezione editoriale: quando il partner applica filtri
      // dinamici, passiamo al catalogo disponibile invece di fingere di filtrarla.
      if (filter === 'all' && isPartnerStorefront() && settings.resetFilters === false && activeAdvancedFilterCount() > 0) {
        filter = 'available';
      }
      if (settings.resetFilters !== false && typeof resetFilterControls === 'function') resetFilterControls(filter);
      setActiveFilter(filter, settings.scroll !== false, settings.writeUrl !== false, !!settings.replaceUrl);
      return filter;
    }

    window.FlorameHomeCatalog = Object.freeze({
      select: selectCatalogView,
      getSelected: function () { return currentFilter || filterFromLocation(); },
      views: Object.freeze(['all', 'available', 'trend', 'newest', 'mine', 'liked'])
    });

    function initHomeExplore() {
      if (!document.querySelector(FILTER_SELECTOR)) return;
      document.addEventListener('click', function (event) {
        var link = event.target && event.target.closest ? event.target.closest(FILTER_SELECTOR) : null;
        if (!link) return;
        if (event.button && event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        var quickFilter = link.getAttribute('data-home-explore-filter') || 'all';
        // Le pill principali sono viste complete, non scorciatoie che ereditano
        // filtri avanzati invisibili. Un'occasione/periodo resta attivo solo
        // quando l'utente lo applica esplicitamente dal pannello Filtri.
        selectCatalogView(quickFilter, { scroll: true, writeUrl: true, resetFilters: true });
      });
      var initial = filterFromLocation();
      var initialParams = new URLSearchParams(window.location.search);
      var initialPeriod = initialParams.get('period') || 'all';
      var initialSort = initial === 'trend' ? 'likes' : (initialParams.get('sort') || 'newest');
      var initialOccasion = normalizeOccasion(initialParams.get('occasion') || 'all');
      var sheetFeed = document.querySelector('[data-home-sheet-feed="' + initial + '"]');
      var sheetPeriod = document.querySelector('[data-home-sheet-period="' + initialPeriod + '"]') || document.querySelector('[data-home-sheet-period="all"]');
      var sheetSort = document.querySelector('[data-home-sheet-sort="' + initialSort + '"]') || document.querySelector('[data-home-sheet-sort="newest"]');
      var sheetOccasion = document.querySelector('[data-home-sheet-occasion="' + initialOccasion + '"]') || document.querySelector('[data-home-sheet-occasion="all"]');
      [sheetFeed, sheetPeriod, sheetSort, sheetOccasion].forEach(function (button) {
        if (button) { button.classList.add('is-selected'); button.setAttribute('aria-pressed', 'true'); }
      });
      setActiveFilter(initial, false, true, true);
      window.addEventListener('florame:partner-picks-availability-change', function () {
        var active = document.querySelector(FILTER_SELECTOR + '.is-active');
        var activeFilter = active ? active.getAttribute('data-home-explore-filter') : defaultCatalogFilter();
        var partnerPicksActive = syncPartnerPickFilter(activeFilter);
        var status = document.getElementById('homeExploreStatus');
        var communityHeading = document.querySelector('#homeCommunitySection .section-head h3');
        if (status && activeFilter === 'all') {
          status.textContent = partnerPicksActive
            ? 'Mostro la vetrina del fiorista.'
            : labels.all;
        }
        if (communityHeading && activeFilter === 'all') {
          communityHeading.textContent = partnerPicksActive ? partnerSelectionLabel() : 'Per te';
        }
      });
      window.addEventListener('popstate', function () {
        syncOccasionButtons(new URLSearchParams(window.location.search).get('occasion') || 'all');
        setActiveFilter(filterFromLocation(), false, false, false);
      });
      document.addEventListener('florame:partner-ready', function () {
        setActiveFilter(filterFromLocation(), false, false, false);
      });
      window.addEventListener('florame:home-catalog-select', function (event) {
        var detail = event && event.detail ? event.detail : {};
        selectCatalogView(detail.view || detail.filter || defaultCatalogFilter(), {
          scroll: detail.scroll !== false,
          writeUrl: detail.writeUrl !== false,
          resetFilters: detail.resetFilters !== false
        });
      });

      try {
        var savedLocation = JSON.parse(window.localStorage.getItem('florame_cap_state') || '{}');
        var locationLabel = document.querySelector('[data-home-location-label]');
        var readableLocation = savedLocation.display || savedLocation.address || savedLocation.formattedAddress || savedLocation.city || savedLocation.cap || '';
        if (locationLabel && savedLocation.verified && readableLocation) locationLabel.textContent = readableLocation;
      } catch (_) {}
      function refreshHomeCartCount() {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          var badge = document.querySelector('[data-home-cart-count]');
          var count = Number(cart && cart.item_count || 0);
          if (!badge) return;
          badge.textContent = String(count);
          badge.hidden = count < 1;
        })
        .catch(function () {});
      }
      refreshHomeCartCount();
      ['florame:cart-updated', 'cart:updated'].forEach(function (name) {
        window.addEventListener(name, refreshHomeCartCount);
      });

      var layer = document.getElementById('homeExploreFilterSheet');
      var openButton = document.querySelector('[data-home-filter-open]');
      var filterSheet = layer ? layer.querySelector('.home-filter-sheet') : null;
      var filterScroll = layer ? layer.querySelector('[data-home-filter-scroll]') : null;
      var filterBackdrop = layer ? layer.querySelector('.home-filter-backdrop') : null;
      var filterDrag = null;
      function resetFilterDrag() {
        filterDrag = null;
        if (filterSheet) {
          filterSheet.classList.remove('is-dragging');
          filterSheet.style.transform = '';
        }
        if (filterBackdrop) filterBackdrop.style.opacity = '';
      }
      function closeFilterSheet() {
        if (!layer) return;
        resetFilterDrag();
        layer.hidden = true;
        document.body.classList.remove('home-filter-open');
        if (openButton) openButton.focus();
      }
      function openFilterSheet() {
        if (!layer) return;
        layer.hidden = false;
        document.body.classList.add('home-filter-open');
        var close = layer.querySelector('.home-filter-close');
        if (close) close.focus();
      }
      if (filterSheet) {
        function beginFilterDrag(clientX, clientY, target) {
          if (layer && layer.hidden) return;
          var fromHandle = target && target.closest
            ? target.closest('.home-filter-handle, .home-filter-header')
            : null;
          if (!fromHandle && filterScroll && filterScroll.scrollTop > 0) return;
          filterDrag = {
            x: clientX,
            y: clientY,
            lastY: clientY,
            startedAt: Date.now(),
            moving: false
          };
        }
        function moveFilterDrag(clientX, clientY, event) {
          if (!filterDrag) return;
          var dx = clientX - filterDrag.x;
          var dy = clientY - filterDrag.y;
          filterDrag.lastY = clientY;
          if (dy <= 0 || Math.abs(dx) > Math.abs(dy) || dy < 8) return;
          filterDrag.moving = true;
          if (event && event.cancelable) event.preventDefault();
          filterSheet.classList.add('is-dragging');
          filterSheet.style.transform = 'translate3d(0,' + Math.min(dy, 220) + 'px,0)';
          if (filterBackdrop) filterBackdrop.style.opacity = String(Math.max(0.25, 1 - (dy / 300)));
        }
        function finishFilterDrag() {
          if (!filterDrag) return;
          var dy = filterDrag.lastY - filterDrag.y;
          var elapsed = Math.max(1, Date.now() - filterDrag.startedAt);
          var velocity = dy / elapsed;
          var shouldClose = filterDrag.moving && (dy >= 90 || (dy >= 44 && velocity >= 0.55));
          if (shouldClose) closeFilterSheet();
          else resetFilterDrag();
        }
        filterSheet.addEventListener('touchstart', function (event) {
          if (!event.touches || event.touches.length !== 1 || (layer && layer.hidden)) return;
          var touch = event.touches[0];
          beginFilterDrag(touch.clientX, touch.clientY, event.target);
        }, { passive: true });
        filterSheet.addEventListener('touchmove', function (event) {
          if (!filterDrag || !event.touches || event.touches.length !== 1) return;
          var touch = event.touches[0];
          moveFilterDrag(touch.clientX, touch.clientY, event);
        }, { passive: false });
        filterSheet.addEventListener('touchend', finishFilterDrag, { passive: true });
        filterSheet.addEventListener('touchcancel', resetFilterDrag, { passive: true });
        filterSheet.addEventListener('mousedown', function (event) {
          if (event.button !== 0) return;
          beginFilterDrag(event.clientX, event.clientY, event.target);
        });
        window.addEventListener('mousemove', function (event) {
          moveFilterDrag(event.clientX, event.clientY, event);
        });
        window.addEventListener('mouseup', finishFilterDrag);
      }
      document.addEventListener('click', function (event) {
        if (event.target && event.target.closest && event.target.closest('[data-home-filter-open]')) openFilterSheet();
      });
      document.querySelectorAll('[data-home-filter-close]').forEach(function (button) { button.addEventListener('click', closeFilterSheet); });
      document.querySelectorAll('[data-home-sheet-feed],[data-home-sheet-period],[data-home-sheet-sort],[data-home-sheet-occasion]').forEach(function (button) {
        button.addEventListener('click', function () {
          var group = button.closest('[data-home-filter-group]');
          if (group) group.querySelectorAll('button').forEach(function (item) { item.classList.remove('is-selected'); item.setAttribute('aria-pressed', 'false'); });
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
          syncAdvancedFilterCount();
        });
      });
      var reset = document.querySelector('[data-home-filter-reset]');
      if (reset) reset.addEventListener('click', function () { resetFilterControls(currentFilter || defaultCatalogFilter()); });
      document.addEventListener('click', function (event) {
        var resetAndApply = event.target && event.target.closest
          ? event.target.closest('[data-home-filter-reset-and-apply]')
          : null;
        if (!resetAndApply) return;
        selectCatalogView(defaultCatalogFilter(), { scroll: true, writeUrl: true, resetFilters: true });
      });
      var apply = document.querySelector('[data-home-filter-apply]');
      if (apply) apply.addEventListener('click', function () {
        var selected = document.querySelector('[data-home-sheet-feed].is-selected');
        selectCatalogView(selected ? selected.getAttribute('data-home-sheet-feed') : (currentFilter || defaultCatalogFilter()), { scroll: true, writeUrl: true, resetFilters: false });
        closeFilterSheet();
      });
      var backToTop = document.querySelector('[data-home-feed-back-to-top]');
      var exploreTop = document.getElementById('homeExplore');
      function updateBackToTop() {
        if (!backToTop || !exploreTop) return;
        var show = window.scrollY > exploreTop.offsetTop + 520;
        backToTop.hidden = !show;
        backToTop.classList.toggle('is-visible', show);
      }
      if (backToTop && exploreTop) {
        backToTop.addEventListener('click', function () {
          var reduceMotion = false;
          try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (_) {}
          exploreTop.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
        window.addEventListener('scroll', updateBackToTop, { passive: true });
        updateBackToTop();
      }
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && layer && !layer.hidden) closeFilterSheet(); });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHomeExplore, { once: true });
    else initHomeExplore();
  })();
